import { Record } from 'immutable'

const Card = Record({
  number:null,
  cvc: null,
  exp_month: null,
  exp_year:null
});
export default Card;
